import type { ReactNode } from "react";
import { Copy } from "lucide-react";
import { copyToClipboard } from "./utils";

// Floating copy button on hover; hidden while an inner input/editor has focus.
export function HoverCopy({
	text,
	label,
	children,
}: {
	text: string;
	label: string;
	children: ReactNode;
}) {
	return (
		<div className="group/copy relative">
			{children}
			{text && (
				<button
					type="button"
					onClick={() => copyToClipboard(text, label)}
					className="absolute right-0 top-0 rounded-md border border-border bg-surface p-1.5 text-muted opacity-0 shadow-sm transition-opacity hover:text-foreground focus-visible:opacity-100 group-hover/copy:opacity-100 group-focus-within/copy:hidden"
					aria-label={`Copy ${label.toLowerCase()}`}
					title={`Copy ${label.toLowerCase()}`}
				>
					<Copy className="h-3.5 w-3.5" />
				</button>
			)}
		</div>
	);
}
